import React from 'react';
import { PropTypes } from 'prop-types';
import { Row, FormElements, Grid, Spinner } from '@custom-components';
import { StyledInfoContainer, StyledContainer } from '../Steps.styles';

function ConnectionType(props) {
  const { mainForm, data, loading, handleChangeOption } = props;

  return (
    <div style={{ marginTop: '5%' }}>
      {loading ? (
        <div style={{ justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
          <Spinner size={22} />
        </div>
      ) : (
        <StyledInfoContainer>
          <StyledContainer>
            <Row>
              <Grid.Col lg={12}>
                <FormElements.Select
                  variant="outlined"
                  id="connectionType"
                  key="connectionType"
                  name="connectionType"
                  label="Select Connection Type"
                  value={mainForm.values.connectionType}
                  options={data}
                  onBlur={mainForm.handleBlur}
                  onChange={(item) => handleChangeOption(mainForm, item, data)}
                  error={!!mainForm.errors.connectionType}
                  errorText={mainForm.errors.connectionType}
                  inputProps={{ readOnly: true }}
                />
              </Grid.Col>
            </Row>
          </StyledContainer>
        </StyledInfoContainer>
      )}
    </div>
  );
}

ConnectionType.propTypes = {
  mainForm: PropTypes.shape({
    values: {
      connectionType: PropTypes.string
    },
    errors: {
      connectionType: PropTypes.string
    },
    handleBlur: PropTypes.func
  }),
  data: PropTypes.arrayOf(PropTypes.shape({})),
  loading: PropTypes.bool,
  error: PropTypes.shape({}),
  handleChangeOption: PropTypes.func
};

ConnectionType.defaultProps = {
  mainForm: {},
  data: [],
  loading: false,
  error: {},
  handleChangeOption: () => {}
};

export default ConnectionType;
